import { useLocation } from "react-router-dom";

type Spec = {
  rows?: number;
  band?: boolean;
  cards?: number;
  reserve: number;
};

const SPECS: Record<string, Spec> = {
  "/": { band: true, rows: 5, reserve: 720 },
  "/subscribers": { rows: 12, reserve: 680 },
  "/audience": { rows: 4, reserve: 520 },
  "/content": { rows: 4, reserve: 620 },
  "/broadcasts": { rows: 3, reserve: 520 },
  "/settings": { cards: 3, reserve: 720 },
};

const DEFAULT: Spec = { rows: 8, reserve: 560 };

const shimmer: React.CSSProperties = {
  background: "var(--c-surface)",
  borderRadius: 6,
};

function Card({ children, h }: { children?: React.ReactNode; h?: number }) {
  return (
    <div style={{
      background: "var(--c-card)", border: "1px solid var(--c-border)",
      borderRadius: "var(--ui-card-radius)", boxShadow: "var(--ui-card-shadow)",
      padding: "var(--ui-space-4)", minHeight: h,
    }}>{children}</div>
  );
}

export function PageSkeleton() {
  const { pathname } = useLocation();
  const spec = SPECS[pathname] ?? DEFAULT;
  const desktop = typeof window !== "undefined"
    && window.matchMedia("(min-width: 1024px)").matches;

  return (
    <div
      style={{
        display: "grid", gap: "var(--ui-space-4)",
        height: desktop ? spec.reserve : undefined,
        minHeight: desktop ? undefined : 420,
        overflow: "hidden",
      }}
      aria-busy="true"
      aria-live="polite"
    >
      <span className="ui-sr-only">Loading…</span>
      <div style={{ minHeight: 46, marginBottom: "var(--ui-space-4)" }}>
        <div style={{ ...shimmer, width: 170, height: 22 }} />
        <div style={{ ...shimmer, width: 300, height: 12, marginTop: 6 }} />
      </div>
      {spec.band && <div style={{ ...shimmer, height: 88 }} />}
      {spec.cards ? (
        <>
          {Array.from({ length: spec.cards }).map((_, i) => (
            <Card key={i} h={160}>
              <div style={{ ...shimmer, width: "38%", height: 14 }} />
              <div style={{ ...shimmer, width: "62%", height: 11, marginTop: 10 }} />
            </Card>
          ))}
        </>
      ) : (
        <Card>
          <div style={{ ...shimmer, width: 190, height: 14 }} />
          {spec.rows && (
            <>
              <div style={{ ...shimmer, height: 32, marginTop: "var(--ui-space-4)", marginBottom: "var(--ui-space-3)" }} />
              <div style={{ border: "1px solid var(--c-border)", borderRadius: "var(--ui-card-radius)", overflow: "hidden" }}>
                <div style={{ height: 33, background: "var(--c-surface)", borderBottom: "1px solid var(--c-border)" }} />
                {Array.from({ length: spec.rows }).map((_, i) => (
                  <div key={i} style={{
                    height: 37, borderBottom: "1px solid var(--c-border)",
                    display: "flex", alignItems: "center", padding: "0 var(--ui-space-3)",
                  }}>
                    <div style={{ ...shimmer, width: `${38 + ((i * 13) % 34)}%`, height: 11 }} />
                  </div>
                ))}
              </div>
            </>
          )}
        </Card>
      )}
    </div>
  );
}
